// extracted by mini-css-extract-plugin
export default {"navigation-popover":"styles_navigation-popover__XBC5o"};